// (function () {
//     'use strict';

//     angular.module("imApp").factory("travelBillService", ['$ihttp', 'p2DataTaskService', function ($ihttp, p2DataTaskService) {
//         let service = {
//             getEdit: function (parms) {
//                 return $ihttp.post({
//                     method: 1255,
//                     parameters: parms || {}
//                 });
//             },
//             listLabours: function (parms) {
//                 return $ihttp.post({
//                     method: 1252,
//                     parameters: parms || {}
//                 });
//             },
//             listProjects: function (parms) {
//                 return $ihttp.post({
//                     method: 1108,
//                     parameters: parms || {}
//                 });
//             },
//             loadTravelBillSrResourcesFromList: function (custact_no) {
//                 return p2DataTaskService.call(1461, {
//                     custact_no: custact_no
//                 });
//             },
//             updateDietDaysInfo: function (edit) {
//                 return $ihttp.post({
//                     method: 1264,
//                     parameters: edit
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 1256,
//                     parameters: edit
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
